import { TextureLoader, CubeTextureLoader } from "three";
import { DDSLoader } from "three/examples/jsm/loaders/DDSLoader.js";
import { HDRLoader } from "three/examples/jsm/loaders/HDRLoader.js";
import { BASE_URL } from "../../html";
class TextureLoaderService {
    constructor() {
        this.textureLoader = new TextureLoader();
        this.cubeLoader = new CubeTextureLoader();
        this.ddsLoader = new DDSLoader();
        this.hdrLoader = new HDRLoader();
        this.onError = (event, requestedPath) => {
            const e = event;
            const target = e === null || e === void 0 ? void 0 : e.currentTarget;
            const sourceUrl = ((target === null || target === void 0 ? void 0 : target.src) !== undefined) ? target.src : "(unknown source)";
            const originalPath = requestedPath !== null && requestedPath !== void 0 ? requestedPath : "(unknown path)";
            console.warn(`[renderer] Error while loading texture. requested="${originalPath}", resolved="${sourceUrl}"`);
        };
        this.setPath("");
    }
    setPath(relativePath) {
        const path = `${BASE_URL}/${relativePath}`;
        this.textureLoader.setPath(path);
        this.cubeLoader.setPath(path);
        this.ddsLoader.setPath(path);
        this.hdrLoader.setPath(path);
    }
    loadTexture(path, onLoad, onProgress, onError) {
        const resolvedOnError = onError !== null && onError !== void 0 ? onError : ((event) => this.onError(event, path));
        return this.textureLoader.load(path, onLoad, onProgress, resolvedOnError);
    }
    loadCube(paths, onLoad, onProgress, onError) {
        const requestedPaths = paths.join(", ");
        const resolvedOnError = onError !== null && onError !== void 0 ? onError : ((event) => this.onError(event, requestedPaths));
        return this.cubeLoader.load(paths, onLoad, onProgress, resolvedOnError);
    }
    loadHDR(path, onLoad, onProgress, onError) {
        const resolvedOnError = onError !== null && onError !== void 0 ? onError : ((event) => this.onError(event, path));
        return this.hdrLoader.load(path, onLoad, onProgress, resolvedOnError);
    }
}
export const textureLoaderService = new TextureLoaderService();
